export default __webpack_public_path__ + "static/media/4.c6561de3.jpeg";